<template>
  <div class="content">
    <CCol ref="content" xs="12" lg="12">
      <CCard>
        <!-- <CCardHeader>All Nodes List</CCardHeader> -->
        <CCardBody>
          <v-card
            style="padding-top: 20px; padding-left: 20px; padding-right: 20px; padding-bottom: 30px;"
            shaped
          >
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <md-card>
                  <md-card-header style="  background-color:#4CAF50;">
                    <h4 class="title">  Parcelles Liste </h4>
                 <!--    <p class="category">Here is a subtitle for this table</p> -->
                  </md-card-header>
                  <md-card-content>
                    <simple-table></simple-table>
                  </md-card-content>
                </md-card>
              </div>
            </div>
          </v-card>
        </CCardBody>
      </CCard>
    </CCol>
  </div>
</template>

<script>
import { SimpleTable } from "@/components";
import router from "@/routes";
export default {
  data() {
    return {
      Nodes: []
    };
  },
  components: {
    SimpleTable
  },
  created() {
    /* if(this.$store.state.Auth == false)
        router.push('/login')*/
    //   GetNodes.getNodes()
    //   .then(data =>{
    //     this.Nodes = data
    //     console.log(this.Nodes)
    //   })
  }
};
</script>
